import React from 'react';
import useTextContents from '../../hooks/useTextContents'
import PageScreen from '../../components/organisms/Page/PageScreen'
import Paragraph from '../../components/atoms/Paragraph/Paragraph'
import { APP_COLOR, APP_FONT_SIZE } from '../../components/atoms/AtomsGlobalProps'


import { ReactComponent as SessionEndIcon } from '../../icons/svg/session-end-page-icon.svg';
import "./SessionEndPage.scss";


const SessionEndPage = () => {
    const textContent = useTextContents()

    return (
        <PageScreen
            title={{ title: textContent('sessionEndPage.heading'), line: true }}
            icon={{ icon: SessionEndIcon, decorative: true, color: 'var(--color-primary-600)' }}
        >
            <Paragraph className='session-end-page-description' align={"center"}>
                {textContent('sessionEndPage.mainContent')}
            </Paragraph>
            <Paragraph size={APP_FONT_SIZE.SMALL} color={APP_COLOR.GRAY} bold align={"center"}>
                {textContent('sessionEndPage.tip')}
            </Paragraph>
        </PageScreen>
    )
}
  
export default SessionEndPage